/**
 * -----------------------------------------------------------------------------
 * Project  : ReelConsensus app - Frontend Styles: theme
 * File     : theme.js
 * Author   : Zachary Dry
 * Created  : 2025-09-18
 * Updated  : 2025-09-19
 * Version  : 1.0
 * License: Proprietary (Company Confidential)
 * -----------------------------------------------------------------------------
 * Description:
 *   Theme or styling utilities for the frontend: theme.
 *   Exports: theme
 *   
 *
 * Dependencies:
 *   - @mui/material/styles
 *
 * Usage:
 *   Import: import theme from '@/styles/theme';
 * -----------------------------------------------------------------------------
 */
import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#7c4dff' },
    secondary: { main: '#ffd54f' },
    background: { default: 'transparent', paper: 'rgba(24,24,33,0.9)' }
  },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 }
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: "Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Arial, sans-serif",
    h4: { fontWeight: 700, letterSpacing: 0.2, fontSize: 'clamp(1.35rem, 1.2rem + 1vw, 2rem)' },
    h5: { fontWeight: 600, letterSpacing: 0.2, fontSize: 'clamp(1.15rem, 1.05rem + 0.6vw, 1.5rem)' },
    h6: { fontWeight: 600, letterSpacing: 0.2, fontSize: 'clamp(1rem, 0.95rem + 0.4vw, 1.25rem)' },
    body1: { lineHeight: 1.6 },
    body2: { lineHeight: 1.55 }
  },
  components: {
    MuiContainer: {
      defaultProps: { maxWidth: 'lg' }
    },
    MuiPaper: {
      styleOverrides: { root: { backdropFilter: 'saturate(120%) blur(8px)' } }
    },
    MuiCard: {
      styleOverrides: { root: { borderRadius: 14 } }
    },
    MuiButton: {
      styleOverrides: { root: { textTransform: 'none', borderRadius: 10 } }
    },
    MuiToolbar: {
      styleOverrides: { root: { minHeight: 56, '@media (min-width:600px)': { minHeight: 64 } } }
    }
  }
});

theme = responsiveFontSizes(theme);

export default theme;


